import { z } from 'zod';

export const CurrencyString = z
  .string()
  .refine((value) => /^((\d{1,3})(,\d{3})*)$/.test(value), {
    message: 'Invalid format. The correct format is dd,ddd.',
  });

export type CurrencyString = z.infer<typeof CurrencyString>;
